import { render, staticRenderFns } from "./AddGroupWizardControl.global.vue?vue&type=template&id=882b82a0&lang=pug&"
import script from "./AddGroupWizardControl.global.vue?vue&type=script&lang=ts&"
export * from "./AddGroupWizardControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports